import { render, staticRenderFns } from "./Promocode.vue?vue&type=template&id=85ba2a9e&scoped=true&"
import script from "./Promocode.vue?vue&type=script&lang=js&"
export * from "./Promocode.vue?vue&type=script&lang=js&"
import style0 from "./Promocode.vue?vue&type=style&index=0&id=85ba2a9e&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.10.1_sqwtrzbl6s4ypz4dmnoirtpj7i/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85ba2a9e",
  null
  
)

export default component.exports